import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import "./modal.scss";

export const ResendOrderModal = ({
  handleClose,
  show,
  handleResend,
  selectedId,
}) => {
  const [sendToCustomer, setSendToCustomer] = useState(false);
  const [sendToProvider, setSendToProvider] = useState(false);
  const [sendToPatient, setSendToPatient] = useState(false);

  const handleCheckboxChange = (setter) => (event) => {
    setter(event.target.checked);
  };

  const handleSubmit = () => {
    // Pass the checkbox states to the handleResend function or use them as needed
    handleResend(sendToCustomer, sendToProvider, sendToPatient);
    handleClose();
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Resend Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Resend Whatsapp messages for Order# {selectedId}?
          <Form>
            <Form.Check
              type="checkbox"
              label="Send to Customer"
              checked={sendToCustomer}
              onChange={handleCheckboxChange(setSendToCustomer)}
              className="mt-3"
            />
            <Form.Check
              type="checkbox"
              label="Send to Provider"
              checked={sendToProvider}
              onChange={handleCheckboxChange(setSendToProvider)}
              className="mt-2"
            />
            <Form.Check
              type="checkbox"
              label="Send to Patient"
              checked={sendToPatient}
              onChange={handleCheckboxChange(setSendToPatient)}
              className="mt-2"
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
            onClick={handleSubmit}
            variant="primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
